import React, { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { Input } from "reactstrap";
import SuccessPopups from "../../../../components/Popups/SuccessPopups";
import { environment } from "../../../../env";
import Table from "../../../../components/Table";
import EmptyTable from "../../../../components/errorComponents/EmptyTable";
import { useDispatch } from "react-redux";
import {
  getFloorTypeAction,
  getSendFromAction,
  loaderAction,
} from "../../../../redux/actions/Index";
import BillSendFromModal from "../../../../components/Modal/BillSendFromModal";
import { useSelector } from "react-redux";
import { warningModalToggle } from "./../../../../redux/actions/Index";
import WarningPopup from "./../../../../components/Popups/WarningPopup";
import { MagnifyingGlass, Trash } from "@phosphor-icons/react";
import { useCallback } from "react";
import { toast } from "react-toastify";
import PathName from "../../../../components/PathName/PathName";

const BillSendFrom = () => {
  const dispatch = useDispatch();

  const SendFrom = useSelector((state) => state?.ModalReducer?.sendFrom);
  const user = useSelector((state) => state?.Reducers?.userdata);
  const [filter, setFilter] = useState([]);

  const onSubmit = (data) => {
    debounce(data);
  };
  const debounce = useCallback(
    _.debounce((_searchVal) => {
      Search(_searchVal);
    }, 500),
    []
  );
  const Search = (query) => {
    let arr = [];
    SendFrom.map((item, index) => {
      if (item.name.toUpperCase().includes(query.toUpperCase())) {
        return arr.push(item);
      }
    });
    if (arr.length == 0) {
      setFilter([]);
      toast.error("Send From Not Found", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setFilter(arr);
    }
  };

  const getSendFrom = () => {
    try {
      axios
        .get(`${environment.baseUrl}bill-send-from/`)
        .then((res) => {
          dispatch(getSendFromAction(res.data));
        })
        .catch((res) => {
          console.log("error");
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => { }, [SendFrom]);

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      ignoreRowClick: true,
      allowOverflow: false,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Email",
      selector: (row) => row.email,
      ignoreRowClick: true,
      allowOverflow: false,
    //   button: true,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Contact",
      selector: (row) => row.contact,
      ignoreRowClick: true,
      allowOverflow: false,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Address",
      selector: (row) => row.address,
      ignoreRowClick: true,
      allowOverflow: false,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "PAN",
      selector: (row) => row.pan,
      ignoreRowClick: true,
      allowOverflow: false,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "GST",
      selector: (row) => row.gst,
      ignoreRowClick: true,
      allowOverflow: false,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "CIN",
      selector: (row) => row.cin,
      ignoreRowClick: true,
      allowOverflow: false,
      style: {
        fontSize: "2.3rem",
      },
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex justify-content-center align-items-center gap-2 ">
          <BillSendFromModal
            button="edit"
            title="Edit Bill Send From"
            data={row}
          />
          {user?.role == "superadmin" && (
            <button
              onClick={() => delite(row.id)}
              id={row.ID}
              className="icon-bg-red border-0 px-2 py-3 rounded"
            >
              <Trash size="28" className="icon-color-red" />
            </button>
          )}
        </div>
      ),
    },
  ];

  const column = [
    {
        name: "Name",
        selector: (row) => row.name,
        ignoreRowClick: true,
        allowOverflow: true,
        style: {
            fontSize: "2.3rem",
        },
    },
    {
        name: "Email",
        selector: (row) => row.email,
        ignoreRowClick: true,
        allowOverflow: false,
      //   button: true,
        style: {
          fontSize: "2.3rem",
        },
      },
      {
        name: "Contact",
        selector: (row) => row.contact,
        ignoreRowClick: true,
        allowOverflow: false,
        style: {
          fontSize: "2.3rem",
        },
      },
      {
        name: "Address",
        selector: (row) => row.address,
        ignoreRowClick: true,
        allowOverflow: false,
        style: {
          fontSize: "2.3rem",
        },
      },
      {
        name: "PAN",
        selector: (row) => row.pan,
        ignoreRowClick: true,
        allowOverflow: false,
        style: {
          fontSize: "2.3rem",
        },
      },
      {
        name: "GST",
        selector: (row) => row.gst,
        ignoreRowClick: true,
        allowOverflow: false,
        style: {
          fontSize: "2.3rem",
        },
      },
      {
        name: "CIN",
        selector: (row) => row.cin,
        ignoreRowClick: true,
        allowOverflow: false,
        style: {
          fontSize: "2.3rem",
        },
      },
  ];

  const delite = (id) => {
    dispatch(warningModalToggle(id));
  };
  const deleteData = (id) => {
    dispatch(loaderAction(true));
    dispatch(warningModalToggle(id));
    axios
      .delete(`${environment.baseUrl}bill-send-from/${id}`)
      .then((res) => {
        if (res.data.code === 200) {
          getSendFrom();
          dispatch(loaderAction(false));
        }
      })
      .catch((res) => {
        dispatch(loaderAction(false));
        console.log("error");
      });
  };

  return (
    <>
      <PathName />
      <SuccessPopups />
      <WarningPopup deleteData={deleteData} />
      <div className="City-main">
        <div className="my-3 pb-1">
          <div className="d-flex align-items-center bg-white px-4 border-radius-10">
            <MagnifyingGlass size={30} />
            <Input
              className="p-4 border-0 shadow-none   w-100 fs-3 title-font-500 fs-2 "
              type="text"
              onChange={(e) => {
                onSubmit(e.target.value);
              }}
              autoComplete="off"
              placeholder="Search Bill Send From Here..."
            />
          </div>
          <br />
        </div>
        <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <h1 className="title-font-bold ">Bill Send From</h1>
              <BillSendFromModal title="Create Bill Send From Name" />
            </div>
            {filter?.length == 0 ? (
              <>
                {SendFrom?.[0] !== undefined ? (
                  <Table
                    columns={user?.role == "user" ? column : columns}
                    data={SendFrom}
                  />
                ) : (
                  <EmptyTable />
                )}
              </>
            ) : (
              <>
                <Table
                  columns={user?.role == "user" ? column : columns}
                  data={filter}
                />
              </>
            )}
          </div>
        </div>
        <div className="d-flex gap-5"></div>
      </div>
    </>
  );
};

export default BillSendFrom;
